export const EA_TRAVEL_RATES_UPDATE_FORM = 'eaTravelRates/updateForm/';
export const EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE = EA_TRAVEL_RATES_UPDATE_FORM + 'setValue';
export const EA_TRAVEL_RATES_UPDATE_FORM_SET_VALID = EA_TRAVEL_RATES_UPDATE_FORM + 'setValid';

export const FROM_CURRENCY_SET_VALUE = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE + 'fromCurrency';
export const FROM_CURRENCY_SET_VALID = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALID + 'fromCurrency';

export const TO_CURRENCY_SET_VALUE = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE + 'toCurrency';
export const TO_CURRENCY_SET_VALID = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALID + 'toCurrency';

export const EXCHANGE_RATE_SET_VALUE = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE + 'exchangeRate';
export const EXCHANGE_RATE_SET_VALID = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALID + 'exchangeRate';

export const ACTIVE_EXCHANGE_RATE_SET_VALUE = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE + 'activeExchangeRate';
export const ACTIVE_EXCHANGE_RATE_SET_VALID = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALID + 'activeExchangeRate';

export const LAST_UPDATED_EXCHANGE_RATE_SET_VALUE = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALUE + 'lastUpdatedExchangeRate';
export const LAST_UPDATED_EXCHANGE_RATE_SET_VALID = EA_TRAVEL_RATES_UPDATE_FORM_SET_VALID + 'lastUpdatedExchangeRate';

export const TRIGGER_UPDATE_DETAILS = EA_TRAVEL_RATES_UPDATE_FORM + 'triggerUpdateDetails/';
export const TRIGGER_UPDATE_SUCCESS = EA_TRAVEL_RATES_UPDATE_FORM + 'triggerUpdateSuccess/';
export const TRIGGER_UPDATE_FAILURE = EA_TRAVEL_RATES_UPDATE_FORM + 'triggerUpdateFailure/';
export const API_PENDING_TRIGGER_UPDATE = EA_TRAVEL_RATES_UPDATE_FORM + 'apiPendingTriggerUpdate/';
export const API_SUCCESS_TRIGGER_UPDATE = EA_TRAVEL_RATES_UPDATE_FORM + 'apiSuccessTriggerUpdate/';
export const API_FAILURE_TRIGGER_UPDATE = EA_TRAVEL_RATES_UPDATE_FORM + 'apiFailureTriggerUpdate/';

export const GET_EXCHANGE_LIST_DETAILS = EA_TRAVEL_RATES_UPDATE_FORM + 'getExchangeDetails/';
export const GET_EXCHANGE_LIST_SUCCESS = EA_TRAVEL_RATES_UPDATE_FORM + 'getExchangeSuccess/';
export const GET_EXCHANGE_LIST_FAILURE = EA_TRAVEL_RATES_UPDATE_FORM + 'getExchangeFailure/';
export const API_PENDING_GET_EXCHANGE_LIST = EA_TRAVEL_RATES_UPDATE_FORM + 'apiPendingGetExchange/';
export const API_SUCCESS_GET_EXCHANGE_LIST = EA_TRAVEL_RATES_UPDATE_FORM + 'apiSuccessGetExchange/';
export const API_FAILURE_GET_EXCHANGE_LIST = EA_TRAVEL_RATES_UPDATE_FORM + 'apiFailureGetExchange/';

export const REINITIALIZE = EA_TRAVEL_RATES_UPDATE_FORM + '/state/reinitialize';

export const setFromCurrencyValue = (value) => ({
    type: FROM_CURRENCY_SET_VALUE,
    value,
});
export const setFromCurrencyValid = (error) => ({
    type: FROM_CURRENCY_SET_VALID,
    error,
});

export const setToCurrencyValue = (value) => ({
    type: TO_CURRENCY_SET_VALUE,
    value,
});
export const setToCurrencyValid = (error) => ({
    type: TO_CURRENCY_SET_VALID,
    error,
});

export const setExchangeRateValue = (value) => ({
    type: EXCHANGE_RATE_SET_VALUE,
    value,
});
export const setExchangeRateValid = (error) => ({
    type: EXCHANGE_RATE_SET_VALID,
    error,
});

export const setActiveExchangeRateValue = (value) => ({
    type: EXCHANGE_RATE_SET_VALUE,
    value,
});
export const setActiveExchangeRateValid = (error) => ({
    type: EXCHANGE_RATE_SET_VALID,
    error,
});

export const setLastUpdatedExchangeRateValue = (value) => ({
    type: LAST_UPDATED_EXCHANGE_RATE_SET_VALUE,
    value,
});
export const setLastUpdatedExchangeRateValid = (error) => ({
    type: LAST_UPDATED_EXCHANGE_RATE_SET_VALID,
    error,
});

export const triggerUpdateDetails = () => ({
    type: TRIGGER_UPDATE_DETAILS,
});

export const triggerUpdateSuccess = (data) => ({
    type: TRIGGER_UPDATE_SUCCESS,
    data,
});

export const triggerUpdateFailure = (error) => ({
    type: VERIFY_FAILURE,
    error,
});

export const apiPendingTriggerUpdate = () => ({
    type: API_PENDING_TRIGGER_UPDATE,
});

export const apiSuccessTriggerUpdate = () => ({
    type: API_SUCCESS_TRIGGER_UPDATE,
});

export const apiFailureTriggerUpdate = () => ({
    type: API_FAILURE_TRIGGER_UPDATE,
});

export const apiTransitionTriggerUpdate = {
    pending: apiPendingTriggerUpdate,
    success: apiSuccessTriggerUpdate,
    failure: apiFailureTriggerUpdate,
};

export const getExchangeList = () => ({
    type: GET_EXCHANGE_LIST_DETAILS,
});

export const getExchangeListSuccess = (data) => ({
    type: GET_EXCHANGE_LIST_SUCCESS,
    data,
});

export const getExchangeListFailure = (error) => ({
    type: GET_EXCHANGE_LIST_FAILURE,
    error,
});

export const apiPendingGetExchangeList = () => ({
    type: API_PENDING_GET_EXCHANGE_LIST,
});

export const apiSuccessGetExchangeList = () => ({
    type: API_SUCCESS_GET_EXCHANGE_LIST,
});

export const apiFailureGetExchangeList = () => ({
    type: API_FAILURE_GET_EXCHANGE_LIST,
});

export const apiTransitionGetExchangeList = {
    pending: apiPendingGetExchangeList,
    success: apiSuccessGetExchangeList,
    failure: apiFailureGetExchangeList,
};

export const initializeUpdateForm = () => ({
    type: REINITIALIZE,
});
